import { render, staticRenderFns } from "./SelectBox2.vue?vue&type=template&id=262eb3ac&"
import script from "./SelectBox2.vue?vue&type=script&lang=js&"
export * from "./SelectBox2.vue?vue&type=script&lang=js&"
import style0 from "./SelectBox2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SelectBox2.vue"
export default component.exports